import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { useLang } from "@/contexts/LangContext";
import { useSettings } from "@/contexts/SettingsContext";

export default function Footer() {
  const { t } = useLang();
  const { address_line, email, web_line } = useSettings();

  return (
    <footer className="bg-[#1c1917] text-[#f8f7f5] mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <h2 className="font-serif-display text-5xl md:text-6xl leading-none">
            Esmalte <span className="italic text-[var(--eafg-copper-light)]">al fuego</span>
            <br />
            Guerrero
          </h2>
          <p className="tracking-eyebrow text-[#a8a29e] mt-6">León · España · est. handmade</p>
        </div>
        <div className="md:col-span-3 space-y-3">
          <div className="tracking-eyebrow text-[#a8a29e] mb-3">Tienda</div>
          <Link to="/tienda/pendientes" className="block hover:text-[var(--eafg-copper-light)]">
            Pendientes
          </Link>
          <Link to="/tienda/collares" className="block hover:text-[var(--eafg-copper-light)]">
            Collares
          </Link>
          <Link to="/tienda/broches" className="block hover:text-[var(--eafg-copper-light)]">
            Broches
          </Link>
        </div>
        <div className="md:col-span-4 space-y-4">
          <div className="tracking-eyebrow text-[#a8a29e] mb-3">{t("contact.title")}</div>
          <div className="flex items-start gap-3">
            <MapPin size={16} strokeWidth={1.5} className="mt-1 text-[var(--eafg-copper-light)]" />
            <span>{address_line}</span>
          </div>
          <div className="flex items-center gap-3">
            <Mail size={16} strokeWidth={1.5} className="text-[var(--eafg-copper-light)]" />
            <a href={`mailto:${email}`} className="hover:underline">
              {email}
            </a>
          </div>
          <div className="flex items-center gap-3">
            <Instagram size={16} strokeWidth={1.5} className="text-[var(--eafg-copper-light)]" />
            <span>@esmaltealfuegoguerrero</span>
          </div>
        </div>
      </div>
      <div className="border-t border-[#44403c]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#a8a29e]">
          <span>© {new Date().getFullYear()} Esmalte Al Fuego Guerrero · {web_line}</span>
          <span>Joyería esmaltada a fuego, hecha en León.</span>
        </div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 pb-6 flex flex-wrap gap-x-5 gap-y-2 text-[11px] text-[#a8a29e]">
          <Link to="/legal/aviso-legal" className="hover:text-[var(--eafg-copper-light)]">Aviso legal</Link>
          <Link to="/legal/privacidad" className="hover:text-[var(--eafg-copper-light)]">Privacidad</Link>
          <Link to="/legal/cookies" className="hover:text-[var(--eafg-copper-light)]">Cookies</Link>
          <Link to="/legal/condiciones-venta" className="hover:text-[var(--eafg-copper-light)]">Condiciones de venta</Link>
        </div>
      </div>
    </footer>
  );
}
